import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IEditorResolverService = ( createDecorator('editorResolverService'));
export { IEditorResolverService };
